import React from 'react';
import { siteConfig } from '../config/siteConfig';
import '../styles/FloatingQuickActions.css';

const FloatingQuickActions = () => {
  const { company, social } = siteConfig;
  const whatsappNumber = company.whatsapp.replace(/[^\d]/g, '');
  const phoneNumber = company.phone.replace(/\s+/g, '');

  return (
    <div className="floating-actions" aria-label="Quick contact actions">
      <a
        href={`https://wa.me/${whatsappNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-action floating-whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
        <span>Chat on WhatsApp</span>
      </a>

      <a
        href={`tel:${phoneNumber}`}
        className="floating-action floating-call"
        aria-label={`Call ${company.phone}`}
      >
        <i className="fas fa-phone"></i>
        <span>Call {company.phone}</span>
      </a>

      {social.instagram && (
        <a
          href={social.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-action floating-instagram"
          aria-label="Open Instagram"
        >
          <i className="fab fa-instagram"></i>
          <span>Instagram</span>
        </a>
      )}
    </div>
  );
};

export default FloatingQuickActions;
